import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { PwaService } from "../pwa-install-prompt/pwa.service";

@Component({
	selector: "app-install",
	templateUrl: "./install.component.html",
	styleUrls: ["./install.component.css"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class InstallComponent {
	private pwaService = inject(PwaService);

	mobileType = computed(() => this.pwaService.mobileType());
	// cSpell:ignore beforeinstallprompt
	canUseAutoInstall = computed(() => !!this.pwaService.promptEvent());

	public async installPwa(): Promise<void> {
		const prompt = this.pwaService.promptEvent();
		if (prompt) {
			try {
				await prompt.prompt();
			} catch (error) {
				console.error("PWA installation failed:", error);
			}
		}
	}
}
